import { render, staticRenderFns } from "./riskTargetProcess.vue?vue&type=template&id=5b29f13e"
import script from "./riskTargetProcess.vue?vue&type=script&lang=js"
export * from "./riskTargetProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b29f13e')) {
      api.createRecord('5b29f13e', component.options)
    } else {
      api.reload('5b29f13e', component.options)
    }
    module.hot.accept("./riskTargetProcess.vue?vue&type=template&id=5b29f13e", function () {
      api.rerender('5b29f13e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/plan/riskTargetProcess.vue"
export default component.exports